import { styled, TextV2 } from '@withjoy/joykit';

export const StyledTitle = styled(TextV2)`
  margin-left: 0.24rem;
  margin-right: 0.24rem;
  word-break: break-word;
`;
